module.exports = __webpack_public_path__ + "static/img/login-bg-117.a5fba9a5.png";